import { ResultLoadingView, AdventureTime, Count, Card } from './ResultLoading.styles';

export const ResultLoading = () => (
  <ResultLoadingView>
    <AdventureTime>Let's find the right healthcare provider for you</AdventureTime>
    <Count />
    <Card />
    <Card />
    <Card />
  </ResultLoadingView>
);
